import 'css-chunk:../components/pop-under/index.module.scss';export default {
  "shown": "_shown_15flr_1",
  "popunder": "_popunder_15flr_5"
};